/* eslint-disable tailwindcss/no-custom-classname */

import {UrlLink} from '../../../../applink/UrlLink';

export function TermsPaid() {
  return (
    <>
      <header>카카오페이지 유료서비스 이용약관</header>
      <main>
        <h2>제1장 총칙</h2>
        <section>
          <h3>제 1 조 (목적)</h3>
          <p>
            본 약관은 (주)카카오엔터테인먼트(이하 "회사"라 합니다)가 제공하는
            카카오페이지 서비스(이하 “서비스”라 합니다) 내에서 유료서비스의
            이용과 관련하여 회사와 회원의 권리, 의무 및 책임사항, 기타 필요한
            사항을 규정함을 목적으로 합니다.
          </p>
        </section>
        <section>
          <h3>제 2 조 (정의)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>본 약관에서 사용하는 용어의 정의는 다음과 같습니다.
              <ol className="inner-ol">
                <li>
                  <span>1.</span>
                  "서비스"라 함은 회사가 회원에게 유·무선 접근기기를 통해
                  제공하는 콘텐츠 및 관련 정보와 소프트웨어 등을 의미합니다.
                </li>
                <li>
                  <span>2.</span>
                  "회원"이라 함은 카카오페이지 이용 약관과 본 약관 그리고
                  개인정보 제공에 동의하여 회사로부터 서비스 이용 자격을 부여
                  받은 이용자를 의미합니다.
                </li>
                <li>
                  <span>3.</span>
                  "콘텐츠"라 함은 디지털 방식으로 제작, 처리되어 회원에게
                  서비스되는 내용물 일체(글, 그림, 사진, 음성, 음향, 동영상
                  등)를 의미합니다.
                </li>
                <li>
                  <span>4.</span>
                  "유료서비스"라 함은 회사가 유료로 제공하는 제1호의 서비스를
                  의미합니다.
                </li>
                <li>
                  <span>5.</span>
                  "접근기기"라 함은 휴대전화, PC, 태블릿 등 콘텐츠를 다운로드
                  받아 설치하여 이용하거나 콘텐츠를 네트워크를 통해 이용할 수
                  있도록 해 주는 기계적 수단을 의미합니다.
                </li>
                <li>
                  <span>6.</span>
                  "캐시"라 함은 회원이 이용권 구매 시 사용할 수 있도록 회사가
                  내용과 조건을 정하여 제공하는 전자적 지급 수단을 의미합니다.
                  회원이 마지막으로 서비스를 이용한 날로부터 5년이 경과할 때까지
                  캐시를 이용하지 않을 경우 상사소멸시효에 따라 소멸될 수
                  있으며, 무상으로 제공된 캐시의 경우 회사의 정책에 따라 소멸될
                  수 있습니다. 캐시의 구매에 관한 자세한 사항은 당사의 이용정책,
                  카카오
                  <a
                    href="https://checkout-web.kakao.com/terms/paid"
                    target="_self"
                  >
                    전자금융거래 이용약관
                  </a>
                  및 앱마켓의 정책을 통해 확인하실 수 있습니다.
                </li>
                <li>
                  <span>7.</span>
                  "이용권"이라 함은 회원이 유료서비스의 이용을 위해 사용할 수
                  있도록 회사가 내용과 조건을 정하여 제공하는 전자적 지급 수단을
                  의미합니다. 이용권은 캐시로 구매할 수 있으며 이용권의 종류,
                  사용방법 등에 대해서는 이용권 구매 시 화면에서 회원에게
                  안내합니다. 회원이 이용권의 구매일로부터 5년이 경과할 때까지
                  이용하지 않을 경우 상사소멸시효에 따라 소멸될 수 있습니다.
                  다만 무상으로 제공된 이용권의 경우 회사의 정책에 따라 소멸될
                  수 있습니다.
                </li>
                <li>
                  <span>8.</span>
                  "포인트", "쿠폰" 등(이하 "포인트 등"이라 합니다)은 회사가
                  회원에게 마케팅이나 프로모션의 목적으로 무상으로 제공하는
                  전자적 지급수단을 의미합니다. 회사가 무상으로 지급한 포인트
                  등은 회사의 정책에 따라 소멸될 수 있습니다.
                </li>
              </ol>
            </li>
            <li className="number-circle-li">
              <span>②</span>본 약관에서 정하지 아니한 부분은 「카카오페이지
              이용약관」, 서비스 가이드, 관계 법령 및 일반 상관례에 따릅니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 3 조(약관의 게시, 개정 등)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>회사는 본 약관의 내용을 회원이 쉽게 확인할 수 있도록
              서비스 초기 화면 또는 팝업화면 등 별도의 연결화면에 게시하며, 본
              약관은 서비스 내에서 유료로 제공되는 서비스를 이용하고자 하는
              회원이 본 약관에 동의함으로써 그 효력이 발생합니다.
            </li>
            <li className="number-circle-li">
              <span>②</span>회사는 「콘텐츠산업진흥법」, 「전자상거래 등에서의
              소비자보호에 관한 법률」, 「약관의 규제에 관한 법률」,
              「정보통신망이용촉진 및 정보보호등에 관한 법률」 등 관련 법령을
              위배하지 않는 범위에서 본 약관을 개정할 수 있습니다.
            </li>
            <li className="number-circle-li">
              <span>③</span>회사가 본 약관을 개정하는 경우에는 개정약관의
              적용일자 및 변경사유를 명시하여 현행 약관과 함께 회사가 운영하는
              서비스 내의 적절한 장소에 개정 약관의 적용일자 15일 전부터
              적용일자 전일까지 공지합니다. 다만, 회원에게 불리하게 약관내용을
              개정하는 경우에는 적용일자 30일 전부터 공지하고, 회원이 가입 시
              제공한 전자우편 등의 전자적 수단을 통하여 고지합니다.
            </li>
            <li className="number-circle-li">
              <span>④</span>
              <strong>
                <u>
                  회사가 본 조에 따라 15일 또는 30일 전에 개정 약관을 공지 또는
                  고지하면서 “개정 약관의 적용일전까지 회원이 거부 의사를
                  표시하지 아니할 경우 약관의 개정에 동의한 것으로 간주한다”는
                  뜻을 명확하게 공지 또는 고지하였음에도, 회원이 명시적으로 약관
                  변경에 대한 거부의사를 표시하지 아니한 경우에는 회원이 개정
                  약관에 동의한 것으로 간주합니다.
                </u>
              </strong>
            </li>
            <li className="number-circle-li">
              <span>⑤</span>회원이 개정 약관의 적용에 동의하지 않는 경우 회사는
              개정 약관의 내용을 적용할 수 없으며, 이 경우 회원은 본 약관에 따른
              서비스 이용계약을 해지할 수 있습니다. 다만, 개정 약관에 동의하지
              않은 회원에 대하여 기존 약관을 더 이상 적용할 수 없는 특별한
              사정이 있는 경우에는 회사가 본 약관에 따른 서비스 이용계약을
              해지할 수 있습니다.
            </li>
            <li className="number-circle-li">
              <span>⑥</span>본 약관은 회원이 본 약관에 동의한 날로부터 회원 탈퇴
              시까지 적용하는 것을 원칙으로 합니다. 단, 제6조 제3항, 제9조 등 본
              약관의 일부 조항은 회원이 탈퇴한 후에도 회사와 회원 사이에
              유효하게 적용될 수 있습니다.
            </li>
            <li className="number-circle-li">
              <span>⑦</span>카카오페이지 유료서비스 이용약관의 제반 규정은,
              「카카오페이지 이용약관」의 관련 규정보다 우선하여 적용되며, 두
              약관의 정의, 내용 등이 서로 상충되는 경우 본 약관의 관련 규정을
              적용합니다. 본 약관에 명시되지 아니한 사항에 대하여는
              「카카오페이지 이용약관」이 적용되며, 카카오페이지 이용약관에도
              정하지 않은 사항에 대해서는 콘텐츠산업진흥법, 전자상거래 등에서의
              소비자 보호에 관한 법률, 약관의 규제에 관한 법률 등 관련 법령에
              따릅니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 4 조 (유료서비스의 내용 등)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회사는 다음 사항을 해당 유료서비스의 이용초기화면이나 팝업화면,
              FAQ 등에 회원이 알기 쉽게 표시합니다.
              <ol className="inner-ol">
                <li>
                  <span>1.</span>
                  유료서비스의 명칭 또는 제호
                </li>
                <li>
                  <span>2.</span>
                  유료서비스의 내용, 이용방법, 이용료 기타 이용조건
                </li>
              </ol>
            </li>
            <li className="number-circle-li">
              <span>②</span>
              회사가 제공하는 유료서비스의 이용이 가능한 접근기기 및 이용에
              필요한 최소한의 기술사양은 권장사양정보에 따릅니다.
            </li>
            <li className="number-circle-li">
              <span>③</span>
              회사는 유료서비스 제공과 관련하여 유료서비스의 교환·반품·보증과 그
              대금 환불의 조건 및 절차에 관한 사항을 이용정책, 팝업화면 등을
              이용하여 회원에게 안내합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 5 조 (이용계약의 성립 등)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회원은 아래 각호에 따른 절차 또는 이와 유사한 절차에 의하여
              유료서비스 이용신청을 합니다. 회사는 유료서비스 이용계약 체결 전에
              아래 각 호의 사항에 관하여 회원이 정확하게 이해하고 실수 또는 착오
              없이 거래할 수 있도록 그와 관련된 정보를 회원에게 제공합니다.
              <ol className="inner-ol">
                <li>
                  <span>1.</span>
                  유료서비스의 내용, 이용방법, 이용료 및 기타 이용조건 확인 및
                  선택
                </li>
                <li>
                  <span>2.</span>결제방법의 선택 및 결제정보의 입력
                </li>
                <li>
                  <span>3.</span>
                  유료서비스의 이용신청에 관한 확인 또는 회사의 확인에 대한 동의
                </li>
              </ol>
            </li>
            <li className="number-circle-li">
              <span>②</span>
              유료서비스 이용계약의 성립시기는 가입완료, 구매완료를 신청절차
              상에서 표시된 시점으로 합니다.
            </li>
            <li className="number-circle-li">
              <span>③</span>
              회원은 본 약관에 동의하고 본 약관에서 정한 이용권 구매 결제수단을
              이용해 이용권을 구매한 후 유료서비스를 이용할 수 있습니다.
            </li>
            <li className="number-circle-li">
              <span>④</span>
              이용권은 유상 이용권과 무상 이용권, 기타 포인트로 분류됩니다.
              회원이 동시에 여러 종류의 이용권을 보유하고 있는 경우 포인트 또는
              무상 이용권이 먼저 소진된 후에 유상 이용권이 사용되며, 동일한
              이용권 간에는 유효기간이 먼저 도래하는 순서에 따라 사용됩니다.
            </li>
            <li className="number-circle-li">
              <span>⑤</span>
              회사는 특정 이용권의 내용을 변경 또는 폐지하는 경우 사전에
              「카카오페이지 이용약관」 제4조에서 정한 바에 따라 회원에게
              통지하고, 특정 이용권의 폐지로 인하여 회원에 대하여 환불이 필요한
              경우 본 약관 또는 별도로 고지하는 환불정책에서 정한 바에 따라
              환불절차를 진행합니다.
            </li>
            <li className="number-circle-li">
              <span>⑥</span>
              회원은 유료서비스 이용을 위해
              <UrlLink url="/policy/payment-service">
                [카카오페이지 결제 서비스 운영정책]
              </UrlLink>
              에서 정하는 내용을 준수하여야 합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 6 조 (미성년자 이용계약에 관한 특칙)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회사는 회원에 대하여 「청소년보호법」 등에 따른 등급 및 연령
              준수를 위해 이용제한이나 등급별 제한을 할 수 있고, 본인 인증
              절차를 거치도록 할 수 있습니다. 또한 회사는 회원이
              「청소년보호법」 등에 따라 연령별 이용가능 등급이 지정되어 있는
              작품을 이용하고자 하는 경우, 관계 법령에 따라 회원의 나이 및 본인
              여부를 확인합니다.
            </li>
            <li className="number-circle-li">
              <span>②</span>
              회사는 만 19세 미만의 미성년 회원이 유료서비스를 이용하고자 하는
              경우에 부모 등 법정대리인의 동의를 얻거나, 계약체결 후 추인을 얻지
              않으면 미성년자 본인 또는 법정대리인이 그 계약을 취소할 수 있다는
              내용을 계약체결 전에 고지하는 조치를 취합니다.
            </li>
            <li className="number-circle-li">
              <span>③</span>
              회원이 미성년자임에도 불구하고 성년자인 제3자의 ID 또는 개인정보
              등을 이용하여 법정대리인의 동의 또는 추인절차를 진행한 경우 또는
              성년자인 제3자의 결제정보를 제3자로부터 동의를 받지 아니하고
              이용하여 결제를 하는 등 속임수로써 회사로 하여금 회원을 성년자라고
              믿게 하였거나, 회원의 법정대리인의 동의가 있었던 것으로 믿게 한
              경우 및 법정대리인이 미성년자에게 범위를 정하여 처분을 허락한
              재산으로 캐시 등을 구매하여 사용한 경우에는 캐시를 구매하였을
              당시에 법정대리인의 동의가 없었더라도 회원 또는 그의 법정대리인이
              이미 사용한 캐시에 대하여 회사에 취소를 요청할 수 없습니다. 다만,
              미성년자인 회원이 아직 사용하지 않은 캐시에 대해서는 본 약관
              제9조(환불정책) 등에서 정한 바에 따라 회사가 회원에게 환불합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 7 조 (지급방법)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회원은 다음 각 호의 결제수단으로 이용권을 구매할 수 있으며, 회사는
              회원이 선택한 결제수단에 대하여 어떠한 명목의 수수료도 추가하여
              징수하지 않습니다. 단, 회원이 선택한 결제수단의 제공업체가 별도로
              존재하는 경우, 회원은 해당 결제수단을 이용하기 전에 해당 결제수단
              제공업체에서 요구하는 절차를 이행하여야 합니다.
              <ol className="inner-ol">
                <li>
                  <span>1.</span>본 약관 제2조 제6호에서 정한 캐시
                </li>
                <li>
                  <span>2.</span>그 밖에 회사에서 정한 결제수단
                </li>
              </ol>
            </li>
            <li className="number-circle-li">
              <span>②</span>
              회사의 정책 및 전항의 결제수단 제공자의 기준에 따라 각 회원의 월
              누적 결제액 또는 충전한도가 제한될 수 있습니다. 해당 기준을 초과한
              경우 유료서비스의 추가 이용은 불가능할 수 있습니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 8 조 (회원의 청약철회)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회원은 본 이용계약에 따라 서비스를 이용하기 위해 유료 결제를 한
              날로부터 7일 이내에 회사에 대해 유료서비스의 이용에 관한 청약을
              철회할 수 있습니다. 다만, 회사가 회원에게 사전에 합의한 내용과
              다르게 서비스를 제공하거나 서비스를 제공하지 아니하는 경우, 회원은
              유료 결제를 한 날로부터 3개월 이내 또는 해당 사실을 알거나 알 수
              있었던 날로부터 30일 이내에 회사에 대해 유료서비스의 이용에 관한
              청약을 철회할 수 있습니다.
            </li>
            <li className="number-circle-li">
              <span>②</span>
              제1항에도 불구하고, 「문화산업진흥 기본법」 제2조 제5호의
              디지털콘텐츠의 제공이 개시된 경우에는 회사의 의사에 반하여
              서비스의 이용에 관한 청약을 철회할 수 없습니다. 다만, 가분적
              디지털콘텐츠로 구성된 계약의 경우에는 디지털콘텐츠의 제공이
              개시되지 아니한 부분에 한하여 철회가 가능합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 9 조 (환불정책)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회원이 유상으로 구매한 이용권의 미사용분에 대해 캐시로의 환불을
              요청하는 경우 회사는 지체없이 환불 처리에 응합니다.
            </li>
            <li className="number-circle-li">
              <span>②</span>
              회사는 회원으로부터 환불의 의사표시를 수령한 날로부터 3 영업일
              이내에 회원이 서비스 이용을 위해 지급하고 사용하지 않은 이용권을
              캐시로 전환하여야 하며, 이 경우 환불수수료는 공제하지 않습니다.
            </li>
            <li className="number-circle-li">
              <span>③</span>
              회원이 캐시의 환불을 요청하는 경우 회사는 소정의 환불수수료(환불을
              요청한 캐시 금액의 10% 또는 1,000원 중 큰 금액)를 공제한 후 환불할
              수 있으나, 회사의 귀책으로 인한 환불의 경우에는 환불수수료를
              공제하지 않습니다. 본 절차와 관련한 구체적인 내용은 카카오
              전자금융거래 이용약관 또는 앱마켓의 정책과 카카오페이지 결제
              서비스 운영정책을 참조하여 주시기 바랍니다.
            </li>
            <li className="number-circle-li">
              <span>④</span>
              회사는 앱마켓 결제(인앱결제)에 있어 해당 앱마켓에 대하여
              대금지급의 정지∙취소 요청 등 「전자상거래등에서의 소비자보호에
              관한 법률」에 따른 관련 조치를 취합니다. 다만, 위와 같은 회사의
              요청에 따른 해당 앱마켓의 조치에 관하여는 해당 앱마켓의 정책을
              참조하여 주시기 바랍니다.
            </li>
            <li className="number-circle-li">
              <span>⑤</span>
              회원에 대한 유료서비스 이행과 관련하여 아래 각 호에 해당하는 자가
              동일인이 아닌 경우, 본 조의 청약철회 등에 따른 콘텐츠대금의 환불과
              관련한 의무의 이행에 있어서 아래 각호에 해당하는 자는 연대하여
              책임을 집니다.
              <ol className="inner-ol">
                <li>
                  <span>1.</span>회사
                </li>
                <li>
                  <span>2.</span>회원으로부터 유료서비스의 대금을 받은 자
                </li>
                <li>
                  <span>3.</span>회원과 이용계약을 체결한 자
                </li>
              </ol>
            </li>
            <li className="number-circle-li">
              <span>⑥</span>
              회원이 법령 및 약관에 근거가 없음에도 앱마켓 결제(인앱결제)정책을
              부정하게 이용하는 등의 방법으로 환불 대상이 아님에도 캐시를 환불
              받은 경우, 회사는 회원이 부당하게 환불받은 금액을 회원에게 청구할
              수 있으며, 회원이 미사용한 이용권과 보유한 캐시에서 공제할 수
              있습니다. 이 경우 회원은 해당 미사용 이용권과 캐시의 사용권한을
              상실합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 10 조 (과오금의 환불)</h3>
          <ol>
            <li className="number-circle-li">
              <span>①</span>
              회원의 서비스 이용과정에서 발생한 과오금의 환불은 회원이 대금을
              결제한 방법과 동일한 방법으로 환불하는 것을 원칙으로 하되, 동일한
              방법으로 환불이 불가능할 때에는 즉시 회원에게 이를 고지하고 회원이
              선택한 방법으로 환불합니다.
            </li>
            <li className="number-circle-li">
              <span>②</span>
              회원의 책임 있는 사유로 인해 회사가 회원에 환불해야 할 과오금이
              발생한 경우, 환불에 소요되는 수수료 등은 회원이 부담합니다. 단,
              회사의 책임 있는 사유로 인해 환불해야 할 과오금이 발생한 경우에는
              환불에 소요되는 수수료 등을 회사가 부담합니다.
            </li>
          </ol>
        </section>
        <section>
          <h3>제 11 조 (콘텐츠 등의 하자에 의한 피해구제)</h3>
          <p>
            회사는 서비스 제공의 일시 중단, 콘텐츠의 하자 등 유료 이용 서비스와
            관련되어 회원의 피해가 발생한 경우, 「콘텐츠이용자보호지침」 및
            「소비자분쟁해결기준」에서 정한 바에 따라 회원의 피해를 배상합니다.
          </p>
        </section>
      </main>
      <footer>
        <p>부칙</p>
        <p>
          공고일자: 2022년 10월 26일
          <br />
          시행일자: 2022년 11월 11일
        </p>
      </footer>
    </>
  );
}
